<h2 mat-dialog-title>{{data.title | translate}}</h2>
<div class="content" mat-dialog-content>
    {{data.msg}}
</div>
<div class="actions" mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">{{"bet_action.return" | translate}}</button>
</div>
